import Modal from './Modal';
import RequestHandler from '../library/RequestHandler';
import {setFormLocale} from '../utils/form';
import {pushEvent} from '../utils/tracking';
import '../utils/loader';

const Request = new RequestHandler();

class FullscreenPopup extends Modal {

    constructor (data)
    {
        super();

        if (data)
        {
            this.data = data;
        }

        if (this.data.type)
        {
            this.type = this.data.type;

            if (this.data.id)
            {
                this.url = '/get/popup/' + this.type + '?id=' + this.data.id;
            }
            else
            {
                this.url = '/get/popup/' + this.type;
            }
        }
        else
        {
            throw new Error('FullscreenPopup: Could not find a type');
        }
    }

    initialize ()
    {
        this.popup = new Modal(this.type);
        this.popup.beforeOpenCallback = () => {
            this.load();
        };
        this.popup.afterContentCallback = () => {
            this.form();
        };
        this.popup.open();
    }

    addEventListeners()
    {
        const _this = this;

        $(document).on('click', '.js-close-modal', function (e) {
            e.preventDefault();

            _this.close();
        });
    }

    processHtml(html)
    {
        const $html = $(html);
        this.popup.populateContent($html);
    }

    form()
    {
        const $form = $('#popup-form');

        $form.formValidation().on('success.field.fv', function (e, data) {

            if (data.fv.getInvalidFields().length === 0)
            {
                data.fv.disableSubmitButtons(false);
            }

        }).on('success.form.fv',(e) => {
            e.preventDefault();

            const $form = $(e.target);

            $form.find('button').loader({ size: 30 });

            Request.post($form.attr('action'), $form.serialize(), (result) => {
                this.successFormHandler(result, $form);
            }, (error) => {
                this.errorFormHandler(error);
            });
        });

        setFormLocale($form, 'nl_NL');
    }

    load()
    {
        this.getFullscreenPopup(this.url);
    }

    onLoadSuccess(html)
    {
        this.processHtml(html);
        //this.hideLoader();
        this.addEventListeners();
    }

    getFullscreenPopup()
    {
        //this.showLoader();

        // let push it to google analytics
        pushEvent('Core', 'GetFullscreenPopup', this.url);

        //Request.get(this.url);

        $.ajax({
            type: 'GET',
            url: this.url,
            data: null,
            timeout: Request.settings.requestTimeout,
            success: (response, textStatus, XMLHttpRequest) => {
                this.onLoadSuccess(response);
            },
            error: (jqXHR, textStatus, error) => {
                if (error !== 'abort')
                {
                    if (jqXHR.status === 500 || jqXHR.status === 404)
                    {
                        this.popup.populateContent('<div class="c-alert c-alert--danger u-absolute-center">We\'ve encountered an error, please try again later</div>');
                        //this.hideLoader();
                    }
                }
            }
        });
    }
    successFormHandler (result, $form) {
        $form.parents('.row').empty().html(result.html);
    }

    /**
     * Do something when the form encountered an error
     * @param error
     */
    errorFormHandler (error) {
        const title = error.errorCode === 3 ? 'Warning' : 'Error';
        const message = error.errorCode === 3 ? error.message : error.errorMessage;

        $('.js-popup-form-button').loader('stop');
        $.growl.error({ title, message });
    }

    close ()
    {
        /*if (this.$modalContainer.length === 0)
        {
            throw ('Modal has not been initialized!');
        }*/

        //this.determineTransitionDuration();
        //this.beforeCloseCallback(this.$modal);
        //this.$modalContainer.removeClass('open');
       // this.setHtmlClass(false);

        /*setTimeout(function () {
            this.$modalContainer.remove();

            if (this.preventBodyScroll)
            {
                $(_this.parentSelector).removeClass('u-overflow-hidden');
            }
        }, this.transitionDuration);*/
    }
}

export default FullscreenPopup;


// WEBPACK FOOTER //
// ./app/src/js/modules/FullscreenPopup.js